import { createAction } from '@reduxjs/toolkit';
import {
  ACTUALIZE_PACKAGE,
  ACTUALIZE_PACKAGE_SUCCESS,
  ACTUALIZE_PACKAGE_FAIL,
  SHOW_PRICE_CHANGED,
  HIDE_PRICE_CHANGED,
  START_ACTUALIZE_PACKAGE,
  STOP_ACTUALIZE_PACKAGE,
  SET_FRONT_ERROR,
} from '../constants/actualization';

import type { MiscData, PackageStateType } from '../package/types';
import type {
  ActualizationChanges,
  ActualizationFrontError,
  MetaPolicy,
} from '../actualization/types';
import type { RoomInfoStateType } from '../domains/room-info/types';

type ActualizePackagePayload =
  | {
      force?: boolean;
    }
  | undefined;

type ActualizationPackageHotel = {
  hotel: {
    id: number;
    name: string;
    stars: number;
    city: string;
    country: string;
    country_code: string;
    facts: {
      no_single_men: {
        enabled: boolean;
        redirect_url: string | null;
      };
    };
    visa: {
      needed: boolean;
      type: string;
      price: number;
      docs_price: number;
      purchasable: boolean;
      policy: string | null;
      text: string | null;
      rules: string | null;
    };
  };
};

type ActualizationPackage = Partial<
  PackageStateType &
    ActualizationPackageHotel & { room_info: RoomInfoStateType }
>;

interface ActualizePackageSuccessPayload {
  lastUpdated: number;
  show_modal_customer: boolean;
  data: {
    rotten: boolean;
    changes: ActualizationChanges;
    prebook_data: MiscData;
    package: ActualizationPackage;
    meta_policies: MetaPolicy[] | null;
  };
}

interface ActualizePackageFailPayload {
  lastUpdated: number;
  ordered?: boolean;
  rotten?: boolean;
  exception?: string | null;
}

type SetFrontErrorPayload = ActualizationFrontError;

export const actualizePackageAction =
  createAction<ActualizePackagePayload>(ACTUALIZE_PACKAGE);

export const actualizePackageSuccess =
  createAction<ActualizePackageSuccessPayload>(ACTUALIZE_PACKAGE_SUCCESS);

export const actualizePackageFail = createAction<ActualizePackageFailPayload>(
  ACTUALIZE_PACKAGE_FAIL,
);

export const showPriceChanged = createAction(SHOW_PRICE_CHANGED);

export const hidePriceChanged = createAction(HIDE_PRICE_CHANGED);

export const startActualizationProcessAction = createAction(
  START_ACTUALIZE_PACKAGE,
);

export const stopActualizationProcessAction = createAction(
  STOP_ACTUALIZE_PACKAGE,
);

export const setFrontErrorAction =
  createAction<SetFrontErrorPayload>(SET_FRONT_ERROR);
